class MainCollection extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init = () => {
    window.addEventListener(Utils.E_FILTER_CHANGE, (event) => {
      this.reload(event.detail.url);
    });
  }

  reload = (url) => {
    axios.get(url).then((response) => {
      const doc = Utils.getDocument(response.data);
      const collection = doc.querySelector('main-collection');
      const old_filters = document.querySelector('collection-filter');
      const new_filters = doc.querySelector('collection-filter');
      if(collection) {
        this.innerHTML = collection.innerHTML;
      }
      if(old_filters && new_filters){
        const idToShow = old_filters.querySelector('.accordion-collapse.show').id;
        new_filters.querySelector(`#${idToShow}`).classList.add('show');
        old_filters.innerHTML = new_filters.innerHTML;
        old_filters.init();
      }
      window.history.replaceState({}, '', url);
    }).catch((error) => {
      Utils.errorHandler({
        message: error.response.data.message || error.message,
        target: 'collection-reload',
        error: error,
        type: 'axios'
      });
    });
  }
}
if(!customElements.get('main-collection')) {
  customElements.define('main-collection', MainCollection);
}

class CollectionFilter extends HTMLElement {
  form; inputs; sliders; collapses;

  constructor() {
    super();
    this.init();
  }
  
  init = () => {
    this.form = this.querySelector('form');
    this.inputs = this.querySelectorAll('input');
    this.sliders = this.querySelectorAll('theme-slider');
    this.inputs.forEach(input => {
      input.addEventListener('change', () => this.onChange(input));
    });
    this.sliders.forEach(slider => {
      slider.addEventListener(Utils.E_SLIDER_CHANGE, () => this.onChange(slider));
    });
  }

  onChange = (input) => {
    const data = new FormData(this.form);
    const queryString = new URLSearchParams(data).toString();
    const url = this.dataset.url + '?' + queryString;
    const detail = {
      url: url,
      change: []
    };
    if(input.tagName == 'THEME-SLIDER') {
      input.getInputs().forEach(input => {
        detail.change.push({name: input.name, value: input.value});
      });
    } else {
      detail.change.push({name: input.name, value: input.value});
    }
    window.dispatchEvent(new CustomEvent(Utils.E_FILTER_CHANGE, { detail: detail }));
    Shopify.analytics.publish(Utils.E_FILTER_CHANGE, detail);
  }

  showCollapse = (id) => {
    const element = document.getElementById(id);
    if(!element) {
      return;
    }
    const collapse = bootstrap.Collapse.getInstance(element) || new bootstrap.Collapse(element);
    if(collapse) {
      collapse.show();
    }
  }
}
if(!customElements.get('collection-filter')) {
  customElements.define('collection-filter', CollectionFilter);
}

class FilterButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', () => this.onClick());
  }

  onClick = () => {
    const filter = document.querySelector('collection-filter');
    filter.showCollapse(this.dataset.open);
  }
}
if(!customElements.get('filter-button')) {
  customElements.define('filter-button', FilterButton);
}

class CollectionHeading extends HTMLElement {
  links;

  connectedCallback() {
    this.links = this.querySelectorAll('a');
    this.init();
  }

  init = () => {
    this.links.forEach((el) => {
      el.addEventListener('click', () => {
        const data = {
          label: el.innerText,
          collection: this.dataset.collection
        };
        Shopify.analytics.publish(Utils.E_PILL_CLICK, data);
        window.dispatchEvent(new CustomEvent(Utils.E_PILL_CLICK, { detail: data }));
      });
    });
  }
}
if(!customElements.get('collection-heading')) {
  customElements.define('collection-heading', CollectionHeading);
}